import styled from 'styled-components';

export const AuthContainer = styled.div`
  height: 90vh;
  width: 95vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
`;
